// extracted by mini-css-extract-plugin
module.exports = {"cursorContainer":"mouse-cursor_cursorContainer__3bUVh","userName":"mouse-cursor_userName__QOldf"};